import React, { useEffect, useState } from 'react';
import Option from '../Option';
import { useSelector } from 'react-redux';

const Questions = ({ item, saveAnswer, savedCurrentAnswers, currentQuestion, currentTab, answers }) => {
    const [selectedOption, setSelectedOption] = useState(null);
    const { taxTabData, bookkeepingTabData } = useSelector((state) => state.TabsState)


    const handleSelection = (option) => {
        setSelectedOption(option);
        saveAnswer(item.id, option);
    };

    useEffect(() => {
        const currentQuestionAndItsAnswer = answers[currentTab?.tab_id]?.find((question, index) => question?.question_id == item?.id)
        if (currentQuestionAndItsAnswer) {
            setSelectedOption(currentQuestionAndItsAnswer?.answer);
            saveAnswer(
                currentQuestionAndItsAnswer?.question_id,
                currentQuestionAndItsAnswer?.answer
            );
        }

    }, [item.id])

    {/* {currentTab?.tab_name == "Company Revenue" && (
                <h4>Note: If you chose Foreign Subsidiary, please enter your U.S company’s revenue and expenses.</h4>
            )} */}

    return (
        <div className={`form-step active ${currentTab?.tab_name == "Company Revenue" ? "company-step" : ""}`} id="step-1">
            <h2>{currentTab?.tab_name}</h2>
            <h3>{item?.question_name}</h3>

            <div className="select_options">
                <div className="options">
                    {item?.options?.map((option, index) => (
                        <Option
                            key={index}
                            selectedOption={selectedOption}
                            handleSelection={handleSelection}
                            option={option}
                        />
                    ))}
                </div>
            </div>
        </div>

    );
};

export default Questions;
